import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const LightHouse: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={361}
    height={315}
    viewBox="0 0 361 315"
    fill="none"
    {...props}
  >
    <path
      fill="#80DFEA"
      fillRule="evenodd"
      d="M354.869 308.786c.014-.163 1.023.319 1.172-1.875.092-1.354-.416-1.96-1.002-2.194-.072-1.667-1.348-3.366-3.041-3.548-1.256-.131-2.148-.28-3.6-.306-.319-.918-1.452-1.687-2.988-1.804-1.537-.117-3.666 1.361-3.952 1.387-1.576.15-151.699-10.163-151.699-10.163l-74.336 10.794 79.967 3.21 143.991 8.255s3.574 1.758 5.436 1.556c1.862-.202 3.021-1.764 3.021-1.764s2.539-.085 3.64-.156c1.328-.085 3.216-1.582 3.404-3.405l-.013.013Z"
      clipRule="evenodd"
    />
    <path
      fill="#80DFEA"
      d="M360.605 307.556h-.019l-4.746-.313c-.091-.006-.098-.228-.085-.338.007-.111.039-.365.143-.345l4.72.592c.092.007.163.104.157.215-.007.104-.078.182-.163.182l-.007.007ZM349.041 303.461c.035-.448-.276-.838-.695-.871-.42-.033-.788.303-.824.751-.035.448.276.838.695.871.42.034.788-.303.824-.751Z"
    />
    <path
      fill="#F9D466"
      fillRule="evenodd"
      d="M191.713 67.166c4.023 0 7.311 2.253 7.311 5v8.223h-14.623v-8.223c0-2.747 3.288-5 7.312-5Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF9132"
      fillRule="evenodd"
      d="M178.718 57.088v50.911h25.722V57.088h-25.722Zm22.435 23.353h-19.545V62.993h19.545V80.44Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF9132"
      fillRule="evenodd"
      d="M156.66 57.088v50.911h23.77V57.088h-23.77Zm20.235 23.353h-17.553V62.993h17.553V80.44Z"
      clipRule="evenodd"
    />
    <path
      fill="#FBE299"
      d="m0 39.412 191.51 30.15v8.815L.026 105.91 0 39.412Z"
    />
    <path fill="#FF9132" d="M181.595 62.191h-4.805v18.744h4.805V62.19Z" />
    <path
      fill="#EB4600"
      fillRule="evenodd"
      d="M203.04 57.088v50.911h22.643V57.088H203.04Zm19.994 23.353h-17.351V62.993h17.351V80.44Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      d="M241.009 115.206a1.306 1.306 0 0 1-1.302-1.302V86.261c0-.716.586-1.302 1.302-1.302.716 0 1.302.586 1.302 1.302v27.643c0 .716-.586 1.302-1.302 1.302Z"
    />
    <path
      fill="#00448A"
      d="M176.602 115.206a1.306 1.306 0 0 1-1.302-1.302V86.261c0-.716.586-1.302 1.302-1.302.716 0 1.302.586 1.302 1.302v27.643c0 .716-.586 1.302-1.302 1.302ZM143.529 115.206a1.305 1.305 0 0 1-1.302-1.302V86.261c0-.716.585-1.302 1.302-1.302.716 0 1.302.586 1.302 1.302v27.643c0 .716-.586 1.302-1.302 1.302Z"
    />
    <path
      fill="#002677"
      d="M213.079 115.206a1.306 1.306 0 0 1-1.302-1.302V86.261c0-.716.586-1.302 1.302-1.302.717 0 1.303.586 1.303 1.302v27.643c0 .716-.586 1.302-1.303 1.302Z"
    />
    <path
      fill="#00448A"
      fillRule="evenodd"
      d="M142.565 90.89v10.658c0 .781.065 1.412.15 1.412h99.03c.078 0 .15-.631.15-1.412V90.89c0-.781-.066-1.42-.15-1.42h-99.037c-.078 0-.149.639-.149 1.42h.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      fillRule="evenodd"
      d="M203.008 90.89v10.658c0 .781.026 1.412.058 1.412h38.763s.059-.631.059-1.412V90.89c0-.781-.026-1.42-.059-1.42h-38.763s-.058.639-.058 1.42Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBE6E1"
      fillRule="evenodd"
      d="M201.126 131.015c-1.029 2.916-1.96 5.182-1.96 5.182h2.129l5.286 165.814s22.722.202 32.832-.085c8.737-.247 8.223-1.588 8.223-1.588l-23.594-164.135h.365s15.586-6.927 20.54-22.135c.957-2.936.99-3.444 1.172-6.042-9.883-.032-42.057.02-42.057.02s.273 5.872-.098 10.937l-2.838 12.045v-.013Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M201.458 135.812c3.704-10.632 2.63-27.78 2.63-27.78l-36.888.019v.092c-7.168-.157-27.982-.606-30.964-.664 2.722 20.358 18.203 28.717 18.203 28.717s.15 0 .417.013l-12.598 164.238h24.694l40.385 1.556-5.879-166.191Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m170.944 244.646-23.386-1.419s-32.825 3.183-32.109 14.303l.039 43.75 21.895.215.169-43.379c.338.006.527.013.527.013l32.865-13.49v.007Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBE6E1"
      fillRule="evenodd"
      d="M165.045 247.816s-28.079.352-27.721 12.051c-.632 1.719-.124 41.634-.124 41.634l27.148-1.022.697-52.663Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      fillRule="evenodd"
      d="M126.003 266.893c2.702 0 4.954 3.86 5.28 8.808l.045 24.857-10.638-.072v-23.405c0-5.599 2.351-10.188 5.319-10.188h-.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#00448A"
      fillRule="evenodd"
      d="M127.436 267.439c1.979 0 3.619 3.796 3.854 8.666l.032 24.486-7.773-.105v-23.014c0-5.508 1.719-10.02 3.887-10.02v-.013Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      fillRule="evenodd"
      d="M189.395 263.188c5.084 0 9.31 4.394 9.915 10.019l-.026 28.483-20-.729.111-26.178c0-6.368 4.42-11.595 9.993-11.595h.007Z"
      clipRule="evenodd"
    />
    <path
      fill="#00448A"
      fillRule="evenodd"
      d="M191.934 263.572c3.724 0 6.823 4.323 7.265 9.857l.091 28.268-14.518-.534-.163-26.191c0-6.263 3.243-11.4 7.325-11.4Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      fillRule="evenodd"
      d="M189.661 158.846c3.907 0 7.162 2.415 7.624 5.501l.059 15.488h-15.371v-14.622c0-3.496 3.398-6.367 7.682-6.367h.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#00448A"
      fillRule="evenodd"
      d="M191.576 159.198c2.93 0 5.371 2.37 5.722 5.41l.046 15.228h-11.536v-14.382c0-3.437 2.552-6.263 5.768-6.263v.007Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      fillRule="evenodd"
      d="M189.661 208.371c3.907 0 7.162 2.415 7.624 5.501l.059 15.489h-15.371v-14.623c0-3.496 3.398-6.367 7.682-6.367h.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#00448A"
      fillRule="evenodd"
      d="M191.628 208.716c2.903 0 5.325 2.369 5.67 5.41l.046 15.228h-11.426v-14.382c0-3.437 2.526-6.263 5.716-6.263l-.006.007Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF9132"
      fillRule="evenodd"
      d="M155.014 55.134h72.858s-6.888-28.346-36.289-27.78c-29.395.567-36.569 27.78-36.569 27.78Z"
      clipRule="evenodd"
    />
    <path
      fill="#EB4600"
      fillRule="evenodd"
      d="M202.357 55.2h25.579s-6.953-28.412-36.354-27.846c8.73 4.076 10.781 27.845 10.781 27.845h-.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF612B"
      d="M228.907 57.894h-75.691a1.628 1.628 0 0 1 0-3.255h75.691a1.628 1.628 0 0 1 0 3.255Z"
    />
    <path
      fill="#002677"
      d="M192.239 26.723c-.436 0-1.972-.45-1.972-.996l1.185-23.77c0-.553.351-.996.787-.996.436 0 .788.45.788.996l1.432 23.77c0 .553-1.784.996-2.22.996Z"
    />
    <path
      fill="#00448A"
      fillRule="evenodd"
      d="M203.327 29.307c0-4.434-4.955-8.047-11.022-8.047-6.068 0-11.035 3.613-11.035 8.047 0 0 2.194 1.458 10.918 1.4 8.723-.06 11.139-1.4 11.139-1.4Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      fillRule="evenodd"
      d="M195.742 30.596c5.847-.332 7.585-1.29 7.585-1.29 0-4.433-4.955-8.046-11.022-8.046 2.363 2.11 3.463 4.856 3.437 9.336Z"
      clipRule="evenodd"
    />
    <path
      fill="#002677"
      d="M192.22 14.223a2.949 2.949 0 1 0 0-5.898 2.949 2.949 0 0 0 0 5.898Z"
    />
  </Box>
)
export default LightHouse
